module.exports = __webpack_public_path__ + "/images/logo-casabebe-it.a7651a9.jpg";